<template>
  <ItemViewTemplate class="tour-view" :loading="loading" v-bind="item">
    <template v-if="item.pricing_table" #pricing-table>
      <div class="pt-12 pt-md-7">
        <v-simple-table class="pricing-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="black--text text-body-2 text-left font-weight-bold">
                  Tarifário
                </th>
                <th class="black--text text-body-2 text-left font-weight-bold">
                  Valor
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(itemPricing, keyPricing) in item.pricing_table"
                :key="keyPricing"
              >
                <td
                  class="
                    grey--text
                    text--darken-2 text-body-1
                    font-weight-normal
                  "
                >
                  {{ keyPricing }}
                </td>
                <td
                  class="
                    grey--text
                    text--darken-2 text-body-1
                    font-weight-normal
                  "
                >
                  {{ itemPricing }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </template>

    <template
      v-if="
        item.tips ||
        item.structure ||
        (item.payment_methods && item.payment_methods.length)
      "
      #more-content
    >
      <v-sheet
        class="d-flex flex-column pb-5 pb-md-7 pb-lg-8 pt-3"
        width="100%"
      >
        <div v-if="item.tips" class="mt-4 text-center">
          <v-btn
            class="primary lighten-4 white--text text-body-1 text-none px-10"
            @click="dialogTips = true"
            height="44px"
            depressed
            rounded
          >
            Dicas

            <v-icon class="ml-2" color="white" size="16">
              fa-external-link-alt
            </v-icon>
          </v-btn>

          <v-dialog v-model="dialogTips" max-width="1200">
            <v-card>
              <v-toolbar color="primary" flat tile>
                <v-container class="d-flex align-center py-0">
                  <v-toolbar-title class="white--text"> Dicas </v-toolbar-title>

                  <v-spacer />

                  <v-btn @click="dialogTips = false" icon>
                    <v-icon class="white--text">fa-times</v-icon>
                  </v-btn>
                </v-container>
              </v-toolbar>

              <div class="px-5 py-7 ck-content" v-html="item.tips"></div>
            </v-card>
          </v-dialog>
        </div>

        <div v-if="item.structure" class="mt-4 text-center">
          <v-btn
            class="primary lighten-4 white--text text-body-1 text-none px-10"
            @click="dialogStructure = true"
            height="44px"
            depressed
            rounded
          >
            Estrutura

            <v-icon class="ml-2" color="white" size="16">
              fa-external-link-alt
            </v-icon>
          </v-btn>

          <v-dialog v-model="dialogStructure" max-width="1200">
            <v-card>
              <v-toolbar color="primary" flat tile>
                <v-container class="d-flex align-center py-0">
                  <v-toolbar-title class="white--text">
                    Estrutura
                  </v-toolbar-title>

                  <v-spacer />

                  <v-btn @click="dialogStructure = false" icon>
                    <v-icon class="white--text">fa-times</v-icon>
                  </v-btn>
                </v-container>
              </v-toolbar>

              <div class="px-5 py-7 ck-content" v-html="item.structure"></div>
            </v-card>
          </v-dialog>
        </div>

        <div v-if="item.payment_methods.length" class="mt-4 text-center">
          <v-btn
            class="primary lighten-4 white--text text-body-1 text-none px-10"
            @click="dialogPaymentMethods = true"
            height="44px"
            depressed
            rounded
          >
            Formas de Pagamento

            <v-icon class="ml-2" color="white" size="16">
              fa-external-link-alt
            </v-icon>
          </v-btn>

          <v-dialog v-model="dialogPaymentMethods" max-width="1200">
            <v-card>
              <v-toolbar color="primary" flat tile>
                <v-container class="d-flex align-center py-0">
                  <v-toolbar-title class="white--text">
                    Formas de Pagamento
                  </v-toolbar-title>

                  <v-spacer />

                  <v-btn @click="dialogPaymentMethods = false" icon>
                    <v-icon class="white--text">fa-times</v-icon>
                  </v-btn>
                </v-container>
              </v-toolbar>

              <div
                class="d-flex justify-center align-center flex-wrap px-5 py-5"
              >
                <div
                  class="ma-2"
                  v-for="(path, keyPayment) in item.payment_methods"
                  :key="keyPayment"
                >
                  <img
                    class="d-block rounded-pill img-payment-method"
                    :src="files + path + '?resize=1&w=80'"
                    width="72"
                    height="72"
                  />
                </div>
              </div>
            </v-card>
          </v-dialog>
        </div>
      </v-sheet>
    </template>
  </ItemViewTemplate>
</template>

<script>
import ItemViewTemplate from "../components/templates/ItemViewTemplate.vue";

const _config = {
  mod: "tours",
};

export default {
  data: () => ({
    loading: true,
    dialogTips: false,
    dialogStructure: false,
    dialogPaymentMethods: false,
    item: {},
  }),
  computed: {
    itemId() {
      return parseFloat(this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1"));
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          id: this.itemId,
        })
        .then((data) => {
          this.item = data;

          this.item.price = data.pricing_table;

          const images = [];

          if (data.img && data.img.list)
            data.img.list.map(({ path }) => {
              images.push(this.files + path);
            });

          this.item.img = images;

          const icons = [];

          if (data.icons && data.icons.list)
            data.icons.list.map(({ path, title }) => {
              icons.push({ icon: this.files + path, title: title });
            });

          this.item.icons = icons;
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  components: {
    ItemViewTemplate,
  },
};
</script>

<style lang="scss" scoped>
.tour-view::v-deep {
  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-accent-lighten2);
    }
  }
}

.img-payment-method {
  border: 2px solid #dddddd;
  -o-object-fit: contain;
  object-fit: contain;
}
</style>
